export default __webpack_public_path__ + "static/media/carousel7.282a5769.jpg";